import { useMemo } from 'react';

const useProgressBarStepperFromTutorial = (steps, activeStep) => {
  const stepperData = useMemo(() => {
    if (!steps || steps.length === 0) {
      return {
        currentStep: 1,
        totalSteps: 3,
        stepTitle: '',
        progress: 33,
        onBack: () => {},
        onNext: () => {},
        showBackButton: false,
        showNextLabel: false,
      };
    }
    const validActiveStep = Math.max(0, Math.min(activeStep, steps.length - 1));
    const currentStepData = steps[validActiveStep] || {};

    return {
      currentStep: validActiveStep + 1,
      totalSteps: steps.length,
      stepTitle: currentStepData.title || '',
      progress: ((validActiveStep + 1) / steps.length) * 100,
      onBack: validActiveStep > 0 ? currentStepData.onBack : () => {},
      showBackButton: validActiveStep > 0,
      showNextLabel: validActiveStep < steps.length - 1,
      secondaryNextLabel: steps[validActiveStep + 1]?.title || '',
    };
  }, [steps, activeStep]);

  return stepperData;
};

export default useProgressBarStepperFromTutorial;
